import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.688 6.427c0-.958.744-1.682 1.596-1.682.853 0 1.596.724 1.596 1.682s-.743 1.682-1.596 1.682c-.852 0-1.596-.724-1.596-1.682Zm1.596-2.998c-1.647 0-2.93 1.371-2.93 2.998 0 1.626 1.283 2.998 2.93 2.998 1.647 0 2.93-1.372 2.93-2.998 0-1.627-1.283-2.998-2.93-2.998Zm-1.98 7.02c-.787 0-1.535.323-2.082.889a3.035 3.035 0 0 0-.847 2.109v1.17c0 .363.298.658.667.658a.662.662 0 0 0 .666-.658v-1.17c0-.456.176-.887.479-1.2a1.555 1.555 0 0 1 1.117-.482h3.96c.413 0 .816.17 1.118.481.303.314.478.745.478 1.2v1.17c0 .364.298.659.667.659a.662.662 0 0 0 .666-.658v-1.17c0-.786-.301-1.545-.847-2.11a2.896 2.896 0 0 0-2.082-.889h-3.96Zm7.369-.818a.524.524 0 0 0 .754 0l2.792-2.858a.554.554 0 0 0 0-.771.524.524 0 0 0-.754 0L13.05 8.474l-1.1-1.124a.524.524 0 0 0-.752 0 .555.555 0 0 0 0 .77l1.475 1.51Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
